import 'css-chunksrc/client/common/resourceAllocationMenu/loader/styles.scss';export default {
  "loader": "_loader_u720e_1",
  "item": "_item_u720e_5",
  "checkbox": "_checkbox_u720e_15",
  "name": "_name_u720e_23"
};